var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-details"},[(_vm.documentDetails && _vm.documentDetails.preSignedUrl)?_c('iframe',{staticStyle:{"width":"100%","height":"500px"},attrs:{"src":_vm.documentDetails.preSignedUrl,"frameborder":"0"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }